"use client";

import NextLink from "next/link";
import { useRouter } from "next/navigation";
import { forwardRef, type ComponentPropsWithoutRef } from "react";

type Props = ComponentPropsWithoutRef<typeof NextLink>;

const IntentLink = forwardRef<HTMLAnchorElement, Props>(function IntentLink(
  { href, prefetch, onMouseEnter, onTouchStart, onFocus, ...rest },
  ref,
) {
  const router = useRouter();
  const target = typeof href === "string" ? href : href.pathname;
  const warm = () => {
    if (prefetch !== false && target && target.startsWith("/")) router.prefetch(target);
  };
  return (
    <NextLink
      ref={ref}
      href={href}
      prefetch={false}
      onMouseEnter={(e) => {
        warm();
        onMouseEnter?.(e);
      }}
      onTouchStart={(e) => {
        warm();
        onTouchStart?.(e);
      }}
      onFocus={(e) => {
        warm();
        onFocus?.(e);
      }}
      {...rest}
    />
  );
});

export default IntentLink;
